import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTES,
  WORKSPACE_ROLE_LEVEL,
  WORKSPACE_ROLE_PERMISSION
} from '../../common/constants';
import AccessControl from '../../components/AccessControl';

import AddPageTemplate from './AddPageTemplate';
import EditPageTemplate from './EditPageTemplate';
import PageTemplates from './PageTemplates';

const PageTemplatesWrapper = () => {
  return (
    <Switch>
      <Route
        exact
        path={ROUTES?.PAGE_TEMPLATES}
        render={(props) => (
          <AccessControl
            modulePermissions={[
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.APP_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              },
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              }
            ]}
          >
            <PageTemplates {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.PAGE_TEMPLATES}/add`}
        render={(props) => (
          <AccessControl
            modulePermissions={[
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.APP_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              },
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              }
            ]}
          >
            <AddPageTemplate {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.PAGE_TEMPLATES}/:id/edit`}
        render={(props) => (
          <AccessControl
            modulePermissions={[
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.APP_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              },
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              }
            ]}
          >
            <EditPageTemplate {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.PAGE_TEMPLATES}/:id`}
        render={() => <Redirect to={ROUTES?.PAGE_TEMPLATES} />}
      />
    </Switch>
  );
};

export default PageTemplatesWrapper;
